import React from 'react'
import { RouteProps } from 'react-router-dom'

import { useHomeTemplateProps } from '../../../templates/Home/useProps'
import HomeTemplate from '../../../templates/Home'
import { useTracking } from '../../../tracking'

const HomePage: React.FC<RouteProps> = () => {
  const templateProps = useHomeTemplateProps()
  useTracking()
  return <HomeTemplate {...templateProps} />
}

export default HomePage
